export default __webpack_public_path__ + "static/media/platin.d4fe7dcd.png";